import { render, staticRenderFns } from "./ItemsCarousel.vue?vue&type=template&id=203a5140&scoped=true"
import script from "./ItemsCarousel.vue?vue&type=script&lang=ts"
export * from "./ItemsCarousel.vue?vue&type=script&lang=ts"
import style0 from "./ItemsCarousel.vue?vue&type=style&index=0&id=203a5140&scoped=true&lang=less"
import style1 from "./ItemsCarousel.vue?vue&type=style&index=1&id=203a5140&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203a5140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('203a5140')) {
      api.createRecord('203a5140', component.options)
    } else {
      api.reload('203a5140', component.options)
    }
    module.hot.accept("./ItemsCarousel.vue?vue&type=template&id=203a5140&scoped=true", function () {
      api.rerender('203a5140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemsCarousel.vue"
export default component.exports